import { useTranslation } from 'react-i18next';

import { TablePagination } from '@mui/material';
import MuiTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { IIdentifiable } from 'interfaces/common';

import { IOutletTableProps } from './types';

import styles from './OutletTable.module.scss';

export default function OutletTable<T extends IIdentifiable>({
  data,
  totalCount = 0,
  columns,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: IOutletTableProps<T>) {
  const { t } = useTranslation();
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onRowsPerPageChange(parseInt(event.target.value));
    onPageChange(0);
  };
  const handleChangePage = (_event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    onPageChange(newPage);
  };
  return (
    <TableContainer>
      <MuiTable>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.id.toString()}
                className={styles.header}
                style={{ ...column.cellStyle, ...column.headerStyle }}
              >
                {column.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.id}>
              {columns.map((column) => (
                <TableCell
                  key={`${row.id}-${column.id.toString()}`}
                  align={column.align}
                  style={{ whiteSpace: 'nowrap', ...column.cellStyle }}
                  className={styles.cellStyle}
                >
                  {column.Cell ? (
                    <column.Cell item={row} />
                  ) : (
                    column.id && column.id in row && <>{row[column.id as keyof T]}</>
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
      <TablePagination
        page={page}
        labelDisplayedRows={({ from, to, count }) =>
    `${from}–${to} ${t('of')} ${count}`
  }
        count={totalCount}
        rowsPerPageOptions={[]}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        classes={{ root: styles.pagination, displayedRows: styles.displayedRows }}
        component="div"
      />
    </TableContainer>
  );
}
